import { useState, VFC } from 'react'
import { DotsIcon } from 'src/assets/svgs'
import { _popupbg, _tooltipshadow } from 'src/styles/colors'
import styled from 'styled-components'

type PopUpMenuProps = {
  actions: {
    label: string
    onClick: VoidFunction
  }[]
}
export const PopUpMenu: VFC<PopUpMenuProps> = ({ actions }) => {
  const [showMenu, setShowMenu] = useState(false)
  return (
    <>
      {showMenu && <OuterDiv onClick={() => setShowMenu(false)} />}
      <PopUpMenuDiv>
        <button onClick={() => setShowMenu(!showMenu)}>
          <DotsIcon />
        </button>
        {showMenu && (
          <MenuContent onClick={(e) => e.stopPropagation()}>
            {actions.map(({ label, onClick }) => (
              <MenuItemButton
                key={label}
                onClick={() => {
                  onClick()
                  setShowMenu(!showMenu)
                }}
              >
                {label}
              </MenuItemButton>
            ))}
          </MenuContent>
        )}
      </PopUpMenuDiv>
    </>
  )
}
const MenuContent = styled.div`
  position: absolute;
  bottom: 1;
  right: 0;
  z-index: 1;
  width: 208px;
  font-weight: 400;
`
const MenuItemButton = styled.button`
  display: block;
  width: 100%;
  background-color: ${_popupbg};
  box-shadow: ${_tooltipshadow};
  padding: 8px 16px;
  color: #606060;
  font-size: 16px;
  :hover {
    background-color: #f6f6f6;
    color: #606060;
  }
  :first-child {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  :last-child {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
`
const OuterDiv = styled.div`
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
`
const PopUpMenuDiv = styled.div`
  position: relative;
  svg {
    transform: translate(0px, -5px) rotate(90deg);
  }
`
